module.exports = __webpack_public_path__ + "img/noHelpListIcon.607f1a3a.png";